import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "cabinet pages-bg_main pages-bg_main--gray" }
const _hoisted_2 = { class: "cabinet__wrapper page-wrapper" }
const _hoisted_3 = { class: "g-container g-container--fit_main-width g-container--space_pages-type relative relative--align_center" }
const _hoisted_4 = { class: "cabinet cabinet--relative" }
const _hoisted_5 = { class: "cabinet__logo disabled-till-xl" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "logo__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo__img",
    width: "82",
    height: "82",
    src: "/static/app/mob-logo.svg",
    alt: "hq vpn logo",
    title: ""
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "logo__text" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo__img",
    src: "/static/app/logo-font.svg",
    alt: "hq vpn logo text",
    title: ""
  })
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "cabinet__title" }
const _hoisted_11 = { class: "ds-caption ds-caption--size_xl ds-caption--size_5xl-xl ds-caption--bold ds-caption--color_white ds-caption--appearance_center" }
const _hoisted_12 = { class: "content-block_main content-block_main--space-sm content-block_main--bordered-none-till-xl content-block_main--cabinet-offsets" }
const _hoisted_13 = { class: "g-row g-row--apperance_center g-row--space_none g-row--align_start-xl" }
const _hoisted_14 = { class: "g-cell g-cols g-cols--12 g-cols--auto-xl" }
const _hoisted_15 = { class: "g-row g-row--apperance_center g-row--space_none g-row--align_start-xl" }
const _hoisted_16 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_17 = { class: "cabinet-block" }
const _hoisted_18 = { class: "cabinet-block__title" }
const _hoisted_19 = { class: "ds-caption ds-caption--bold ds-caption--size_3exl ds-caption--size_4xls-xl ds-caption--color_dark-blue" }
const _hoisted_20 = { class: "cabinet-block__button" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "hq-btn__text ds-caption ds-caption--color_white ds-caption--bold" }
const _hoisted_23 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_24 = { class: "g-row g-row--apperance_center g-row--space_none g-row--align_start-xl g-row--justify_center" }
const _hoisted_25 = {
  key: 0,
  class: "content-info-block content-info-block--cabinet-style content-info-block--offset-bottom_main content-info-block--flex"
}
const _hoisted_26 = { class: "content-info-block__title content-info-block__title--width-12" }
const _hoisted_27 = {
  key: 0,
  class: "g-cell g-cols g-cols--12"
}
const _hoisted_28 = { class: "content-info-block content-info-block--cabinet-style content-info-block--cabinet-border-radius content-info-block--offset-bottom_main content-info-block--flex" }
const _hoisted_29 = { class: "content-info-block__element content-info-block__element--width-md" }
const _hoisted_30 = { class: "content-info-block__title content-info-block__title--width-12" }
const _hoisted_31 = { class: "ds-caption ds-caption--medium ds-caption--size-xs ds-caption--size_2md-xl ds-caption--color_second-gray" }
const _hoisted_32 = { class: "content-info-block__info content-info-block__info--subscription-type content-info-block__info--width-12" }
const _hoisted_33 = { class: "ds-caption ds-caption--bold ds-caption--size_lg ds-caption--size_4xls-xl ds-caption--color_black" }
const _hoisted_34 = { class: "content-info-block__element content-info-block__element--width-sm" }
const _hoisted_35 = { class: "content-info-block__title" }
const _hoisted_36 = { class: "ds-caption ds-caption--medium ds-caption--size_2md ds-caption--color_second-gray ds-caption--appearance_center-xl" }
const _hoisted_37 = { class: "content-info-block__info content-info-block__info--provider-info" }
const _hoisted_38 = { class: "ds-caption ds-caption--bold ds-caption--size_4xls ds-caption--color_black ds-caption--appearance_center-xl" }
const _hoisted_39 = { class: "content-info-block__element content-info-block__element--width-md" }
const _hoisted_40 = { class: "content-info-block__title" }
const _hoisted_41 = { class: "ds-caption ds-caption--medium ds-caption--size_2md ds-caption--color_second-gray" }
const _hoisted_42 = { class: "content-info-block__info content-info-block__info--browser-info" }
const _hoisted_43 = { class: "output-block output-block--apparance_wrap relative" }
const _hoisted_44 = { class: "output output--style_main-white output--cabinet output--ip output--fs_4xl" }
const _hoisted_45 = { class: "output-block__img output-block__img--rtl output-block__img--ip-style" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  width: "27",
  height: "27",
  src: "/static/app/copy-icon.svg",
  alt: "copy icon",
  title: ""
}, null, -1)
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "content-info-block__element content-info-block__element--width-sm content-info-block__element--space-bottom_sm" }
const _hoisted_49 = { class: "content-info-block__info content-info-block__info--button" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "hq-btn__text ds-caption ds-caption--color_white ds-caption--bold" }
const _hoisted_52 = { class: "content-info-block__element content-info-block__element--width-12" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "ds-caption ds-caption--medium ds-caption--size_xs ds-caption--color_second-gray ds-caption--appearance_underline ds-caption--line-h_1" }
const _hoisted_55 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_56 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SPAN = _resolveComponent("SPAN")!
  const _component_copy_to_clip_board = _resolveComponent("copy-to-clip-board")!
  const _component_modal_trigger = _resolveComponent("modal-trigger")!
  const _component_ui_limit_pagination = _resolveComponent("ui-limit-pagination")!
  const _component_email_change_form = _resolveComponent("email-change-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              class: "logo link",
              href: $setup.props.mainPage || '',
              target: "_self"
            }, _hoisted_9, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString($setup.$t("Личный кабинет")), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("p", _hoisted_19, _toDisplayString($setup.$t("Мои подписки")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("a", {
                          class: "hq-btn hq-btn--green hq-btn--centered hq-btn--full_width hq-btn--br-radius_main hq-btn--cabinet-size link",
                          href: $setup.props.paymentPage || ''
                        }, [
                          _createElementVNode("span", _hoisted_22, _toDisplayString($setup.$t("Купить еще подписку")), 1)
                        ], 8, _hoisted_21)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      (!$setup.kyesList.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, _toDisplayString($setup.$t('Нет активных подписок')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.kyesList, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (item.is_active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("p", _hoisted_31, [
                                        _createVNode(_component_SPAN, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.$t("Тип подписки")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("span", _hoisted_33, _toDisplayString($setup.keysTypes[item.ordered_mode]), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("p", _hoisted_36, [
                                        _createVNode(_component_SPAN, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.$t("Осталось дней")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("p", _hoisted_38, _toDisplayString($setup.getDaysForDate(item.active_till)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _createElementVNode("p", _hoisted_41, [
                                        _createVNode(_component_SPAN, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.$t("Ключ")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("span", _hoisted_44, _toDisplayString(item.key), 1),
                                        _createElementVNode("div", _hoisted_45, [
                                          _createVNode(_component_copy_to_clip_board, {
                                            text: item.key,
                                            centered: true
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_46
                                            ]),
                                            _: 2
                                          }, 1032, ["text"])
                                        ]),
                                        _createVNode(_component_modal_trigger, {
                                          component: "QrModal",
                                          initial: item.key,
                                          classes: ["modal--size_xl modal--qr-style"]
                                        }, {
                                          default: _withCtx(({ open }) => [
                                            _createElementVNode("img", {
                                              class: "output-block__img output-block__img--second",
                                              onClick: _withModifiers(($event: any) => (open()), ["prevent"]),
                                              width: "27",
                                              height: "27",
                                              src: "/static/app/qr-code-icon.svg",
                                              alt: "qr code icon",
                                              title: ""
                                            }, null, 8, _hoisted_47)
                                          ]),
                                          _: 2
                                        }, 1032, ["initial"])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", {
                                        class: "hq-btn hq-btn--green hq-btn--centered hq-btn--cabinet-size_sm hq-btn--br-radius_main",
                                        onClick: _withModifiers(($event: any) => ($setup.updateKey(item.key)), ["prevent"])
                                      }, [
                                        _createElementVNode("p", _hoisted_51, _toDisplayString($setup.$t("Продлить ключ")), 1)
                                      ], 8, _hoisted_50)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _createVNode(_component_modal_trigger, {
                                      component: "KeyGenModal",
                                      initial: {key: item.key, getList: $setup.getSubscription},
                                      classes: ["modal--size_xl modal--key-gen-style"],
                                      onOnGenerate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.test()))
                                    }, {
                                      default: _withCtx(({ open }) => [
                                        _createElementVNode("div", {
                                          class: "content-info-block__info content-info-block__info--link link",
                                          onClick: _withModifiers(($event: any) => (open()), ["prevent"])
                                        }, [
                                          _createElementVNode("span", _hoisted_54, _toDisplayString($setup.$t("Сбросить код")), 1)
                                        ], 8, _hoisted_53)
                                      ]),
                                      _: 2
                                    }, 1032, ["initial"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256)),
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_ui_limit_pagination, {
                          pagination: $setup.pagination,
                          onInput: $setup.handlePaginate
                        }, null, 8, ["pagination"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_email_change_form)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}